module.exports = __webpack_public_path__ + "static/media/buy_finish_service_help_3.d28abba9.jpg";